import { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  Grid,
  TextField,
} from "../../../../../components";

const AdicionarConvenioDialog = ({
  open,
  setOpen,
  convenios,
  boletos,
  setBoletos,
  boletoSelecionado,
}) => {

  const [convenioSelecionado, setConvenioSelecionado] = useState(null);

  useEffect(() => {
    if (open) {
      setConvenioSelecionado(boletoSelecionado.convenioSelecionado);
    }
  }, [open])

  const handleCloseDialog = () => {
    setConvenioSelecionado(null);
    setOpen(false);
  }

  const handleSalvarConvenio = (event) => {
    event.preventDefault();
    const index = boletos?.findIndex(
      (item) => item.id === boletoSelecionado.id
    );
    const produtosXmlTemp = boletos.map((item, _index) => {
      if (_index === index) {
        return {
          ...item,
          convenioSelecionado
        };
      } else {
        return item;
      }
    });
    setBoletos(produtosXmlTemp);
    handleCloseDialog();
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      disableClickEventBubbling
      fullWidth
      maxWidth="xs"
    >
      <Card>
        <CardHeader title="Convênio Bancário" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                id="convenioId"
                name="convenioId"
                options={convenios}
                noOptionsText="Sem opções"
                autoHighlight
                getOptionLabel={(option) => (option?.numero ? `${option.numero} - ${option.descricao}`: "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    margin="normal"
                    label="Convênio"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) => setConvenioSelecionado(value)}
                value={convenioSelecionado}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <DialogActions>
        <Button variant="contained" onClick={handleCloseDialog}>
          Fechar
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleSalvarConvenio}
        >
          <i
            className="ph-fill ph-plus-circle"
            style={{ fontSize: 22, marginRight: 10, color: "white" }}
          ></i>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdicionarConvenioDialog;
